
import Vue from "vue";

export default Vue.extend({
  name: "FormConfigMachine",
  props: {
    data: Object,
    onUpdateState: Function,
    searchBearing: Function,
    bearings: Array,
  },
  data() {
    return {
      inputRules: [(v) => v >= 0 || "Value must be non-negative"],
      speedRules: [(v) => +v > 0 || "Value must be greater than 0"],
      speedRangeError: "",
    };
  },
  computed: {
    sensor() {
      return (this as any).data.item.item;
    },
  },
  methods: {
    handleKeyDown(event) {
      if (event.key === "-" || event.key === "e" || event.key === "E") {
        event.preventDefault();
      }
    },
    handleSpeedSwap() {
      const s = (this as any).sensor;
      const min = +s.min_speed;
      const max = +s.max_speed;
      if (min > max) {
        s.min_speed = max;
        s.max_speed = min;
      }
      (this as any).speedRangeError = +s.min_speed === +s.max_speed ? "Min and Max speed must not be equal" : "";
      (this as any).onUpdateState();
    },
  },
});
